import React, { createContext, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { initAxiosWithNavigation } from '../Services/Axios/axiosConfig';

const NavigateContext = createContext<{ navigate: (path: string) => void } | null>(null);

export function NavigateProvider({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();

  // Initialise Axios avec la fonction de navigation
  useEffect(() => {
    console.log('Initialisation de Axios avec navigate');
    initAxiosWithNavigation(navigate);
  }, [navigate]);

  return (
    <NavigateContext.Provider value={{ navigate }}>
      {children}
    </NavigateContext.Provider>
  );
}

export function useAppNavigate() {
  const context = useContext(NavigateContext);
  if (!context) {
    throw new Error('useAppNavigate doit etre utilise dans un NavigateProvider');
  }
  return context.navigate;
}

